import React from 'react'
// @ts-ignore no types
import { Text, Button, Image } from '@adc/ui-core'
import classNames from 'classnames/bind'
import AccessOffMarketIcon from './access-off-market.svg'
import SaveListingsIcon from './save-listings.svg'
import StayAheadIcon from './stay-ahead.svg'
import RealTimeAlertsIcon from './real-time-alerts.svg'
import cls from './styles.scss'

const cx = classNames.bind(cls)

interface DrawerContent {
  elmId: string
  getStarted: () => void
  onClose: () => void
  startTutorial: () => void
}

interface IconItem {
  elmId: string
  label: string
  src: string
  title: string
}

const IconItem = ({ elmId, src, title, label }: IconItem) => (
  <div className={cx('new-icon-container')}>
    <Image
      alt={title}
      className={cx('image')}
      data-elm-id={`${elmId}-${title}`}
      size='tiny'
      src={src}
    />
    <div className={cx('icon-text')}>
      <Text.Body weight='heavy' size='normal'>
        {title}
      </Text.Body>
      <Text.Body size='normal'>{label}</Text.Body>
    </div>
  </div>
)

const NewOnboardingDrawer = ({
  elmId,
  getStarted,
  onClose,
  startTutorial,
}: DrawerContent) => {
  return (
    <div
      className={cx('onboarding-drawer', 'new-onboarding-drawer')}
      data-elm-id={`${elmId}_drawer_content`}
    >
      <Text.Header color='info' level={2}>
        Unlock a More Personalized Experience
      </Text.Header>
      <Text.Header className='u-mb-2' color='nearBlack' level={4}>
        {'Create your account to:'.toUpperCase()}
      </Text.Header>

      <div className={cx('icon-row')}>
        <IconItem
          elmId={elmId}
          label='off-market properties'
          src={AccessOffMarketIcon}
          title='Access'
        />
        <IconItem
          elmId={elmId}
          label='and custom searches'
          src={SaveListingsIcon}
          title='Save listings'
        />
      </div>
      <div className={cx('icon-row')}>
        <IconItem
          elmId={elmId}
          label='all in one dashboard'
          src={StayAheadIcon}
          title='Stay ahead —'
        />
        <IconItem
          elmId={elmId}
          label='property alerts'
          src={RealTimeAlertsIcon}
          title='Get real-time'
        />
      </div>

      <div className='u-mt-6'>
        <Button
          role='primary'
          isStretch
          onClick={getStarted}
          elmId={`${elmId}_get_started_button`}
        >
          Create a Free Account Now
        </Button>
        {startTutorial && (
          <div className='u-mt-2'>
            <Button
              role='secondary'
              isStretch
              onClick={startTutorial}
              elmId={`${elmId}_start_tour_button`}
            >
              Take a Tour
            </Button>
          </div>
        )}
        <div className='u-mt-4'>
          <strong>
            <a onClick={onClose} data-elm-id={`${elmId}_skip_button`}>
              Skip
            </a>
          </strong>
        </div>
      </div>
    </div>
  )
}

export default NewOnboardingDrawer
